import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles"; // Importer useTheme

const WP_URL = process.env.REACT_APP_WP_URL || "https://mycover-up.fr";

const DiverBar = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
        backgroundColor: theme.palette.custom.blue,
        padding: {
          xs: "20px 10px",
          sm: "30px 20px",
          md: "40px",
        },
        color: "white",
        paddingBottom: {
          xs: "10px",
          sm: "120px",
          md: "170px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          maxWidth: "1200px",
          margin: "0 auto",
          flexWrap: "wrap",
        }}
      >
        {/* Colonne 1 */}
        <Box
          sx={{
            flex: 1,
            margin: {
              xs: "10px 5px",
              sm: "10px 10px",
              md: "0 20px",
            },
            minWidth: "200px",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/logo-horizontal-white.png`}
            alt="Logo"
            sx={{
              height: { xs: "6vh", sm: "7vh", md: "8vh" },
              maxWidth: "88%",
              objectFit: "contain",
            }}
          />
          <Typography sx={{ fontSize: "0.9em", margin: "5px 0" }}>
            14 rue des frères Peugeot,
          </Typography>
          <Typography
            sx={{
              fontSize: "0.9em",
              margin: "5px 0",
              fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
            }}
          >
            31130 Balma
          </Typography>
        </Box>

        {/* Colonne 2 */}
        <Box
          sx={{
            flex: 1,
            margin: {
              xs: "10px 5px",
              sm: "10px 10px",
              md: "0 20px",
            },
            minWidth: "200px",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontSize: "1.2em",
              marginBottom: "10px",
              fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
            }}
          >
            Navigation
          </Typography>
          <Box component="ul" sx={{ listStyleType: "none", padding: 0 }}>
            {[
              {
                text: "Créer mon cache Clim",
                href: `${WP_URL}/`,
              },
              {
                text: "Notre Marque",
                href: `${WP_URL}/decouvrir-mycoverup/`,
              },
              {
                text: "Nos réalisations",
                href: `${WP_URL}/nos-realisations/`,
              },
              {
                text: "Contact",
                href: `${WP_URL}/contact/`,
              },
            ].map((item, index) => (
              <Box
                component="li"
                key={index}
                sx={{
                  marginBottom: "5px",
                  fontSize: "0.9em",
                  fontFamily:
                    "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                }}
              >
                <a
                  href={item.href}
                  rel="noopener noreferrer"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  {item.text}
                </a>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Colonne 3 */}
        <Box
          sx={{
            flex: 1,
            margin: {
              xs: "10px 5px",
              sm: "10px 10px",
              md: "0 20px",
            },
            minWidth: "200px",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontSize: "1.2em",
              marginBottom: "10px",
              fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
            }}
          >
            Liens Utiles
          </Typography>
          <Box component="ul" sx={{ listStyleType: "none", padding: 0 }}>
            {[
              {
                text: "Mentions légales",
                href: `${WP_URL}/mentions-legales`,
              },
              {
                text: "Politique de confidentialité",
                href: `${WP_URL}/politique-de-confidentialite`,
              },
              {
                text: "CGV",
                href: `${WP_URL}/conditions-generales-de-vente`,
              },
              {
                text: "Expédition & Remboursements",
                href: `${WP_URL}/expeditions_retours`,
              },
            ].map((item, index) => (
              <Box
                component="li"
                key={index}
                sx={{
                  marginBottom: "5px",
                  fontSize: "0.9em",
                  fontFamily:
                    "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                }}
              >
                <a
                  href={item.href}
                  rel="noopener noreferrer"
                  style={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  {item.text}
                </a>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Colonne 4 */}
        <Box
          sx={{
            flex: 1,
            margin: {
              xs: "10px 5px",
              sm: "10px 10px",
              md: "0 20px",
            },
            minWidth: "200px",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontSize: "1.2em",
              marginBottom: "10px",
              fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
            }}
          >
            Une Question ?
          </Typography>
          <Button
            variant="contained"
            href={`${WP_URL}/contact/`}
            sx={{
              backgroundColor: "white",
              color: theme.palette.custom.blue,
              padding: "10px 20px",
              borderRadius: "50px",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#005a8d",
                color: "white",
              },
              marginTop: { xs: "10px", md: "0" },
              fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
            }}
          >
            Contactez-nous
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DiverBar;
